// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orbit-dialog-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.orbit-dialog-wrapper .orbit-dialog-rnd {
  pointer-events: all;
}
.orbit-dialog-wrapper .ant-modal-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 0 6px 5px #eee;
}
.orbit-dialog-wrapper .ant-modal-header {
  display: flex;
  justify-content: space-between;
  padding: 8px 24px;
  border-bottom: 1px solid #eee;
}
.orbit-dialog-wrapper .ant-modal-title {
  line-height: 32px;
  font-size: 14px;
}
.orbit-dialog-wrapper .no-drag-container {
  display: flex;
  flex: auto;
  flex-direction: column;
  overflow: auto;
  cursor: default;
}
.orbit-dialog-wrapper .no-drag-container .ant-modal-body {
  flex: auto;
  overflow: auto;
  padding: 8px 24px;
}
.orbit-dialog-wrapper .react-draggable {
  transform: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/libs/dialog/index.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AACF;AARA;EAUI,mBAAA;AACJ;AAXA;EAcI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;AAAJ;AAnBA;EAuBI,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,6BAAA;AADJ;AAzBA;EA8BI,iBAAA;EACA,eAAA;AAFJ;AA7BA;EAmCI,aAAA;EACA,UAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AAHJ;AApCA;EA0CM,UAAA;EACA,cAAA;EACA,iBAAA;AAHN;AAzCA;EAiDI,0BAAA;AALJ","sourcesContent":[".orbit-dialog-wrapper {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n\n  .orbit-dialog-rnd {\n    pointer-events: all;\n  }\n\n  .ant-modal-content {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    background-color: #fff;\n    box-shadow: 0 0 6px 5px #eee;\n  }\n\n  .ant-modal-header {\n    display: flex;\n    justify-content: space-between;\n    padding: 8px 24px;\n    border-bottom: 1px solid #eee;\n  }\n\n  .ant-modal-title {\n    line-height: 32px;\n    font-size: 14px;\n  }\n\n  .no-drag-container {\n    display: flex;\n    flex: auto;\n    flex-direction: column;\n    overflow: auto;\n    cursor: default;\n\n    .ant-modal-body {\n      flex: auto;\n      overflow: auto;\n      padding: 8px 24px;\n    }\n  }\n\n  .react-draggable {\n    transform: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
